export default "__VITE_ASSET__fIeoUz4J__"